import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { BasketActionTypes, BasketActions } from '../';
import { BasketDetailsModel } from 'models/Basket';
import { ErrorAction } from 'store';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { basketStorage } from 'storages';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface LoadBasketAction extends Action<BasketActionTypes.LOAD_BASKET> {
}

export interface LoadBasketActionStart extends Action<BasketActionTypes.LOAD_BASKET_START> {
}

export interface LoadBasketActionSuccess extends Action<BasketActionTypes.LOAD_BASKET_SUCCESS> {
    basket: BasketDetailsModel;
}

export interface LoadBasketActionError extends ErrorAction<BasketActionTypes.LOAD_BASKET_ERROR> {
}

export interface ClearBasketAction extends Action<BasketActionTypes.CLEAR_BASKET> {
}

export const loadBasket: () => LoadBasketAction = () => ({
    type: BasketActionTypes.LOAD_BASKET
});
loadBasket[ACTION_CREATOR_NAME] = 'loadBasket';

export type LoadBasketFunc = (...args: Parameters<typeof loadBasket>) => void;

export function* loadBasketSaga(): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.LOAD_BASKET_START,
    });

    try {
        let sessionId = userHelper.getSessionId();
        let username = userHelper.getCurrentUserName();
        let basket: BasketDetailsModel;

        if (sessionId) {
            basket = yield api.hybris.getBasketDetailsBySessionId(username, sessionId);
        } else {
            const existingBasketInfo = yield api.hybris.getBasketInfo(username);
            const basketInfo = (username && existingBasketInfo) ? existingBasketInfo : yield api.hybris.createBasket(username);

            basket = yield api.hybris.getBasketDetailsByBasketId(username, basketInfo.guid);
        }

        userHelper.saveSessionId(basket.session.sessionId);
        basketStorage.saveBasket(basket);

        yield put<BasketActions>({
            type: BasketActionTypes.LOAD_BASKET_SUCCESS,
            basket
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.LOAD_BASKET_ERROR,
            error: errorToBasketErrorModel(error, 'loadBasketSaga')
        });

        return false;
    }
}
